import { KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum, ProviderSettings } from '@kaltura-ott/tvpil';
import { computed, observable } from 'mobx';
import { container, injectable, singleton } from 'tsyringe';

import { Subscription } from '../../../entities';
import { ProvidersRepository } from '../../../providersRepository';
import type { TransactionStore } from '../../../transaction/transaction-store';
import { DeviceStore } from '../../../user';
import { LoginStore } from '../../../user/login-store';
import { SubpageStore } from '../subpage-store';

/**
 * @category Store
 */
@singleton()
@injectable()
export class SubscriptionStore extends SubpageStore {
  subtype: UIDAPresentationTypeEnum.subscription = UIDAPresentationTypeEnum.subscription;

  @observable subscriptions: Subscription[] = [];
  @observable offers: Subscription[] = [];
  @observable heroes: Subscription[] = [];
  @observable additionPlans: Subscription[] = [];
  @observable additionalBasePlans: Subscription[] = [];
  @observable plans: Subscription[] = [];
  @observable externalLink?: string;

  @observable providerSettings?: ProviderSettings;
  @observable isReady = false;

  constructor(props: KuxFilteredCategoriesDTO, categoryTree: KuxFilteredCategoriesDTO, children: []) {
    super(props, categoryTree, children);
    const transactionStore = container.resolve<TransactionStore>('transactionStore');
    transactionStore.subpageProperty = this.subpageProperty;
  }

  /**
   *   call init on Subscription page load
   *   @observable subscriptions, offers, heroes are items to show on the page
   */

  async init() {
    super.init();
    const deviceStore = container.resolve<DeviceStore>('deviceStore');
    const loginStore = container.resolve<LoginStore>('loginStore');
    const transactionStore = container.resolve<TransactionStore>('transactionStore');

    await transactionStore.initSubscriptions();
    this.subscriptions = transactionStore.subscriptions;
    this.offers = transactionStore.offers;
    this.heroes = transactionStore.heroes;
    this.additionPlans = transactionStore.additionPlans;
    this.additionalBasePlans = transactionStore.additionalBasePlans;
    this.plans = transactionStore.plans;
    this.externalLink = `${this.subpageProperty.externalPortalUrl}?id=${deviceStore.householdDevice?.externalId}&token=${loginStore.accessToken}`;

    const providersRepository = container.resolve<ProvidersRepository>('providersRepository');

    this.providerSettings = providersRepository.providerSettings;

    this.isReady = true;
  }

  @computed get mySubscriptions() {
    return this.subscriptions.filter(
      (subscription) => subscription.data.dependencyType !== 'BASE' && subscription.isPurchased,
    );
  }
}
